//@flow
import React from 'react';
import { delay } from 'h-commons';

type Props = { isRotating: boolean }
type State = { state: boolean }

function withRotateOnClick(children, additional) {
    return class extends React.Component<Props, State> { 
        static displayName = 'withRotateOnClick';
        constructor(props) {
            super(props);
            this.state = {
                state: false
            };
        }

        toggleState = () =>  {
            this.setState({
                state: !this.state.state
            });
        }

        onClicked = () => {
            this.toggleState();
            delay(1200).then(() => this.toggleState());
        }

        render() {
            const className = this.state.state || this.props.isRotating ? 'rotating' : '';
            return (
                <div className="h-flexbox--vc" onClick={this.onClicked}>
                    <span className={className}>
                        { children }
                    </span>
                    { additional }
                </div>
            )
        }
    }
}

export {
    withRotateOnClick
}